import { render, staticRenderFns } from "./ReferralProductsEligible.vue?vue&type=template&id=34c5c781&"
import script from "./ReferralProductsEligible.vue?vue&type=script&lang=js&"
export * from "./ReferralProductsEligible.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports